import { Pick } from '@40seas/entities/common';
import { Funds } from './funds.entity';

export class AllocationTrackingDto extends Pick(Funds, ['unmatchedReason', 'matchingDetails', 'matchingMethod']) {}
